import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { PasswordInput } from "@/components/PasswordInput";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [nova, setNova] = useState("");
  const [conf, setConf] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nova.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres");
    if (nova !== conf) return toast.error("As senhas não conferem");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: nova });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      nav("/login");
    } catch (e2) { toast.error(e2.response?.data?.detail || "Não foi possível redefinir"); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <AuthShell title="Link inválido" subtitle="O link de redefinição está incompleto ou expirou."
        footer={<Link to="/esqueci-senha" className="flex items-center gap-1 text-sm text-primary mt-2"><ArrowLeft className="w-4 h-4" /> Solicitar novo link</Link>} >
        <div />
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Crie sua nova senha" subtitle="Defina uma senha para acessar sua conta."
      footer={<Link to="/login" className="flex items-center gap-1 text-sm text-primary mt-2"><ArrowLeft className="w-4 h-4" /> Voltar ao login</Link>} >
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <div className="space-y-2"><Label>Nova senha</Label>
          <PasswordInput value={nova} onChange={(e) => setNova(e.target.value)} data-testid="reset-nova" /></div>
        <div className="space-y-2"><Label>Confirmar nova senha</Label>
          <PasswordInput value={conf} onChange={(e) => setConf(e.target.value)} data-testid="reset-conf" /></div>
        <Button type="submit" className="w-full h-12 text-base font-bold" disabled={loading} data-testid="reset-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar nova senha"}
        </Button>
      </form>
    </AuthShell>
  );
}
